export enum InvoiceStatusEnum{
    OPEN = 'OPEN',
    UNDER_APPROVAL = 'UNDER APPROVAL',
    APPROVED = 'APPROVED'
}